
import { User } from '../auth/User';
import { Division } from '../types/Division';
import { ApiRoutes, getFullApiRoute, replaceRouteParams } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';


export class DivisionAPI {

    //This will get all divisions for current user tenantId
    static async getAll(user: User): Promise<Division[]> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.DIVISIONS), {"id": user.attributes.tenant_id}),
            'GET',
            null,
            null,
            user
        );
        return result?.data || [];
    }

    static async updateOne(user: User, data: Division): Promise<Division | undefined> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.DIVISIONS), {"id": user.attributes.tenant_id })+`${data.id ? `/${data.id}` : ''}`,
            data.id ? 'PUT' : 'POST',
            data,
            new Headers({'Content-Type': 'application/json'}),
            user
        );
        //Check if we have a result and if it is object or array, if array just retun the first item as that is what we expect
        return result && result.data ? (Array.isArray(result.data) ? result.data[0] : result.data) : undefined;
    }    

    static async deleteOne(user: User, data: Division): Promise< {} | undefined> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.DIVISIONS), {"id": user.attributes.tenant_id })+`/${data.id}`,
            'DELETE',
            null,
            null,
            user
        );
        //Check if we have a result and if it is object or array, if array just retun the first item as that is what we expect
        return result && result.data ? (Array.isArray(result.data) ? result.data[0] : result.data) : undefined;
    }
}